// Source: https://github.com/vinted/dwh-schema-registry/blob/5387d2ce7b44ee93711a15dfb97c60a4d984f22c/avro/events/common/shared/user.avdl#L25
type UserTarget =
  | 'apply_for_stellar_seller_supplier'
  | 'learn_about_donations_from_donations_overview'
  | 'set_up_donations'
  | 'start_donations'
  | 'manage_donations'
  | 'save_donations_changes'
  | 'stop_donations'

type FundraiserClickEventArgs = {
  target: UserTarget
  screen?: string | null
  targetDetails?: string | number
}

type FundraiserClickEventExtra = {
  target: UserTarget
  screen?: string
  target_details?: string | number
}

export const fundraiserClickEvent = (args: FundraiserClickEventArgs) => {
  const { target, screen, targetDetails } = args

  const extra: FundraiserClickEventExtra = {
    target,
  }

  if (screen) extra.screen = screen

  if (targetDetails) extra.target_details = targetDetails

  return {
    event: 'user.click_donations',
    extra,
  }
}

type DonationsClickEventArgs = {
  target: UserTarget
  screen?: string | null
  targetDetails?: string | number
}

type DonationsClickEventExtra = {
  target: UserTarget
  screen?: string
  target_details?: string | number
}

export const donationsClickEvent = (args: DonationsClickEventArgs) => {
  const { target, screen, targetDetails } = args

  const extra: DonationsClickEventExtra = {
    target,
  }

  if (screen) extra.screen = screen

  if (targetDetails) extra.target_details = targetDetails

  return {
    event: 'user.click_donations',
    extra,
  }
}
